const TaxRollHeader = [
  {
    text: '', value: 'hasFiles', sortable: false, formatter: 'file',
  },
  { text: 'Type', value: 'taxType' },
  { text: 'Year', value: 'taxYear', formatterTwo: 'txtColorChange' },
  { text: 'TID', value: 'taxId', formatterTwo: 'txtColorChange' },
  { text: 'PID', value: 'propertyOrParcelId' },
  {
    text: 'Desc/Situs',
    value: 'situsAddress',
    formatter: 'shortenCharacter',
    isItSitusAddress: true,
    shortenCharacterlength: 20,
  },
  {
    text: 'Base Tax',
    value: 'totalTax',
    align: 'right',
    formatter: 'amount',
    sortable: false,
  },
  {
    text: 'Still Due',
    value: 'totalDue',
    align: 'right',
    formatter: 'amount',
    formatterTwo: 'txtColorChange',
    sortable: false,
  },
  {
    text: '+ Fees & Pen',
    value: 'feesAndPen',
    align: 'right',
    formatter: 'amount',
    formatterTwo: 'txtColorChange',
    sortable: false,
  },
  // this is add some width to the fees and pen column
  {
    text: '',
    value: 'spacer',
    sortable: false,
    width: '20px',
  },
  {
    text: 'Mtg Code', value: 'mtgCode', width: '40px', sortable: false,
  },
];

const HistoryTransactionListHeader = [
  { text: 'Type', value: 'taxType', sortable: false },
  { text: 'Year', value: 'taxYear', sortable: false },
  { text: 'Tax ID', value: 'taxId', sortable: false },
  { text: 'PID', value: 'propertyOrParcelId', sortable: false },
  {
    text: 'Base Tax',
    value: 'totalTax',
    align: 'right',
    formatter: 'amount',
    sortable: false,
  },
  {
    text: 'Still Due',
    value: 'totalDue',
    align: 'right',
    formatter: 'amount',
    sortable: false,
  },
  {
    text: '+ Fees & Pen',
    value: 'feesAndPen',
    align: 'right',
    formatter: 'amount',
    formatterTwo: 'txtColorChange',
    sortable: false,
  },
  {
    text: 'Owner Name',
    value: 'name1',
    formatter: 'combineName',
    combineTextFileds: ['name1', 'name2'],
    sortable: false,
  },
  {
    text: 'C/O Name',
    value: 'inCareOf1',
    formatter: 'combineName',
    combineTextFileds: ['inCareOf1', 'inCareOf2'],
    sortable: false,
  },
  {
    text: 'Address 1',
    value: 'address1',
    sortable: false,
  },
  {
    text: 'Address 2',
    value: 'address2',
    sortable: false,
  },
  {
    text: 'City',
    value: 'city',
    sortable: false,
  },
  {
    text: 'State',
    value: 'state',
    sortable: false,
  },
  {
    text: 'Zip',
    value: 'zip',
    sortable: false,
  },
  {
    text: 'Mtg Code', value: 'mtgCode', width: '40px', sortable: false,
  },
  {
    text: 'Cert#',
    value: 'certNumber',
    sortable: false,
  },
];

const StatusCodesHeader = [
  {
    text: 'Status',
    value: 'statusCode',
    sortable: false,
  },
  {
    text: 'Description',
    value: 'description',
    sortable: false,
  },
];

const DelqHeader = [
  {
    text: 'Year',
    value: 'taxYear',
    sortable: false,
  },
  {
    text: 'PID',
    value: 'propertyOrParcelId',
    sortable: false,
  },
  {
    text: 'TID',
    value: 'taxId',
    sortable: false,
  },
  {
    text: 'Tax Due',
    value: 'taxAmountDue',
    sortable: false,
    align: 'right',
    formatter: 'amount',
  },
  {
    text: 'Total Due',
    value: 'feesAndPen',
    sortable: false,
    align: 'right',
    formatter: 'amount',
    formatterTwo: 'txtColorChange',
  },
];

const CommentsHeader = [
  {
    text: 'Date',
    value: 'createdAt',
    formatter: 'shortDate',
    sortable: false,
  },
  {
    text: 'Memo',
    value: 'comment',
    sortable: false,
  },
];

const AdjustmentsHeader = [
  {
    text: 'Date',
    value: 'adjDate',
    formatter: 'shortDate',
    sortable: false,
  },
  {
    text: 'A/U',
    value: 'adjOrUpd',
    sortable: false,
  },
  {
    text: 'Type',
    value: 'type',
    sortable: false,
  },
  {
    text: 'Cert No',
    value: 'certNumber',
    sortable: false,
  },
  {
    text: 'Tax Amount',
    value: 'taxAmt',
    align: 'right',
    formatter: 'amount',
    sortable: false,
  },
  {
    text: 'Comments',
    value: 'comments',
    sortable: false,
  },
];

const commentsHeaders = [
  {
    text: 'Date',
    formatter: 'shortDate',
    value: 'createdAt',
  },
  {
    text: 'Category',
    value: 'categoryName',
  },
  {
    text: 'Username',
    value: 'userName',
  },
  {
    text: 'Comment',
    value: 'comment',
    formatter: 'shortenCharacter',
    shortenCharacterlength: 90,
  },
];

const PickListHeaders = [
  {
    text: 'Year',
    value: 'taxYear',
    sortable: false,
  },
  {
    text: 'Tax ID',
    value: 'taxId',
    // sortable: false,
  },
  {
    text: 'Owner Name',
    value: 'name1',
    formatter: 'combineName',
    combineTextFileds: ['name1', 'name2'],
    // sortable: false,
  },
  {
    text: 'Total Due',
    value: 'feesAndPen',
    formatterTwo: 'txtColorChange',
    align: 'right',
    formatter: 'amount',
    sortable: false,
  },
];

const ProtestPaymentsHeaders = [
  {
    text: 'Year',
    value: 'taxYear',
    sortable: false,
  },
  {
    text: 'Tax ID',
    value: 'taxId',
    sortable: false,
  },
  {
    text: 'Owner Name',
    value: 'name1',
    formatter: 'combineName',
    combineTextFileds: ['name1', 'name2'],
    sortable: false,
  },
  {
    text: 'Total Tax',
    value: 'totalTax',
    align: 'right',
    formatter: 'amount',
    sortable: false,
  },
  {
    text: 'Tax Due',
    value: 'totalDue',
    align: 'right',
    formatter: 'amount',
    sortable: false,
  },
  {
    text: 'Amt Paid',
    value: 'totalPaid',
    align: 'right',
    formatter: 'amount',
    sortable: false,
  },
  {
    text: 'Amt Still Due',
    value: 'amountStillDue',
    align: 'right',
    formatter: 'amount',
    sortable: false,
  },
  {
    text: 'Amt Paid Under Protest',
    value: 'amountPaidUnderProtest',
    align: 'right',
    formatter: 'amount',
    class: 'with-divider-left',
    enableLine: true,
    sortable: false,
  },
  {
    text: 'Amt Paid No Protest',
    value: 'amountPaidNoProtest',
    align: 'right',
    formatter: 'amount',
    sortable: false,
  },
  {
    text: 'Total Pmt',
    value: 'totalPayment',
    align: 'right',
    formatter: 'amount',
    sortable: false,
  },
];

const ProtestPaymentsHeadersTwo = {
  MainHeadersNames: [
    {
      text: '',
      cols: '7',
      id: 1,
    },
    {
      text: 'Current Payment',
      cols: '4',
      cellClass: 'with-divider-left',
      id: 3,
    },
  ],
};

const protestTaxFundsHeader = [
  {
    text: 'Fiscal Year',
    value: 'fiscalYear',
    sortable: false,
  },
  {
    text: 'Fund#',
    value: 'fund',
    sortable: false,
  },
  {
    text: 'Description',
    value: 'description',
    sortable: false,
  },
];

const FeesHeaders = [
  {
    text: 'Fees',
    value: 'feeNumber',
    sortable: false,
    class: 'table-headers-fees-feeNumber-col',
    id: 'tableHeadersFeesFeeNumberCol',
  },
  {
    text: 'Description',
    value: 'feeDescription',
    sortable: false,
    class: 'table-headers-fees-feeDescription-col',
    id: 'tableHeaderFeesFeeDescriptionCol',
  },
  {
    text: 'Effective date',
    value: 'effectiveDate',
    sortable: false,
    class: 'table-headers-fees-effectiveDate-col',
    id: 'tableHeadersFeesEffectiveDateCol',
  },
  {
    text: 'Paid date',
    value: 'paymentDate',
    sortable: false,
    class: 'table-headers-fees-paymentDate-col',
    id: 'tableHeadersFeesPaymentDateCol',
  },
  {
    text: 'Amount',
    value: 'feeAmount',
    align: 'right',
    formatter: 'amount',
    sortable: false,
    class: 'table-headers-fees-feeAmount-col',
    id: 'tableHeadersFeesFeeAmountCol',
  },
];

const paymentsRecordsHeaders = [
  {
    text: 'Date',
    value: 'paymentDate',
    formatter: 'shortDate',
    sortable: false,
    class: 'table-headers-payments-date-col',
    id: 'tableHeadersPaymentsDateCol',
  },
  {
    text: 'Payment#',
    value: 'payment',
    sortable: false,
    class: 'table-headers-payments-paymentnum-col',
    id: 'tableHeadersPaymentsPaymentNumCol',
  },
  {
    text: 'Taxes',
    value: 'taxesPaid',
    align: 'right',
    formatter: 'amount',
    sortable: false,
    class: 'table-headers-payments-taxes-col',
    id: 'tableHeadersPaymentsTaxesCol',
  },
  {
    text: 'Penalty',
    value: 'totalAllPenaltyAmt',
    align: 'right',
    formatter: 'amount',
    sortable: false,
    class: 'table-headers-payments-penalty-col',
    id: 'tableHeadersPaymentsPenaltyCol',
  },
  {
    text: 'Fees',
    value: 'totalAllFees',
    align: 'right',
    formatter: 'amount',
    sortable: false,
    class: 'table-headers-payments-fees-col',
    id: 'tableHeadersPaymentsFeesCol',
  },
  {
    text: 'Payment Method',
    value: 'paymentMethod',
    sortable: false,
    class: 'table-headers-payments-method-col',
    id: 'tableHeadersPaymentsMethodCol',
  },
  {
    text: 'Paid By',
    value: 'paidBy',
    sortable: false,
    class: 'table-headers-payments-paidby-col',
    id: 'tableHeadersPaymentsPaidByCol',
    formatter: 'shortenCharacter',
    shortenCharacterlength: 30,
  },
  {
    text: 'Attachments',
    value: 'hasFiles',
    sortable: false,
    formatter: 'file',
    class: 'table-headers-payments-attachments-col',
    id: 'tableHeadersPaymentsAttachmentsCol',
  },
];

const taxPaymPaymentsHeaders = [
  {
    text: 'Payment Method', value: 'paymentType', sortable: false,
  },
  {
    text: 'Check Number', value: 'checkNumber', sortable: false,
  },
  {
    text: 'Card Type', value: 'creditType', sortable: false,
  },
  {
    text: 'Payment Amount', value: 'amount', sortable: false,
  },
  {
    text: 'Paid By', value: 'paidBy', sortable: false,
  },
];

const taxDetailsPaymentsHeaders = [
  {
    text: 'Type', value: 'taxTypeDesc', sortable: false,
  },
  {
    text: 'Tax Yr', value: 'taxYear', sortable: false,
  },
  {
    text: 'Tax ID', value: 'taxId', sortable: false,
  },
  {
    text: 'Receipt #', value: 'reciept', sortable: false,
  },
  {
    text: 'Owner Name', value: 'ownerName', sortable: false,
  },
  {
    text: 'Tax Amt',
    value: 'taxAmt',
    sortable: false,
    align: 'right',
    formatter: 'amount',
  },
  {
    text: 'Penalty',
    value: 'penaltyAmt',
    sortable: false,
    align: 'right',
    formatter: 'amount',
  },
  {
    text: 'Fees',
    value: 'totalFees',
    sortable: false,
    align: 'right',
    formatter: 'amount',
  },
  {
    text: 'Total',
    value: 'total',
    sortable: false,
    align: 'right',
    formatter: 'amount',
  },
];

const ownerTransactionsHeader = [
  {
    text: ' ', value: 'hasFiles', sortable: false, formatter: 'file',
  },
  {
    text: 'Year',
    value: 'taxYear',
    sortable: false,
    formatterTwo: 'txtColorChange',
  },
  { text: 'Owner#', value: 'ownerId', formatterTwo: 'txtColorChange' },
  {
    text: 'Name',
    value: 'name1',
    formatter: 'combineName',
    combineTextFileds: ['name1', 'name2'],
    changeTheTxtClrIfThisFieldsExits: ['inCareOf1', 'inCareOf2'],
  },
  {
    text: 'C/O Name',
    value: 'inCareOf1',
    formatter: 'combineName',
    combineTextFileds: ['inCareOf1', 'inCareOf2'],
    sortable: false,
  },
  {
    text: 'Address',
    value: 'comOwnerAddress',
  },
  { text: 'TID', value: 'taxId' },
  { text: 'BID', value: 'baseId' },
  { text: 'Type', value: 'taxType' },
  {
    text: 'Base Tax',
    value: 'totalTax',
    align: 'right',
    formatter: 'amount',
    sortable: false,
  },
  {
    text: 'Still Due',
    value: 'totalDue',
    align: 'right',
    formatter: 'amount',
    formatterTwo: 'txtColorChange',
    sortable: false,
  },
  {
    text: '+ Fees & Pen',
    value: 'feesAndPen',
    formatterTwo: 'txtColorChange',
    align: 'right',
    formatter: 'amount',
    sortable: false,
  },
];

const mobileHomeHeader = [
  {
    text: 'Tax Year',
    value: 'taxYear',
    sortable: false,
  },
  { text: 'Tax ID', value: 'taxId' },
  { text: 'Name', value: 'name1' },
  { text: 'Parcel ID', value: 'propertyOrParcelId', formatter: 'pId' },
  { text: 'VIN', value: 'mhVin' },
  { text: 'Decal', value: 'mhDecal' },
  { text: 'Title', value: 'mhTitle' },
];

const browsePaidByHeader = [
  {
    text: 'Tax Year',
    value: 'taxYear',
    sortable: false,
  },
  { text: 'Tax ID', value: 'taxId', sortable: false },
  {
    text: 'Owner Name',
    value: 'name1',
    formatter: 'combineName',
    combineTextFileds: ['name1', 'name2'],
    sortable: false,
  },
  {
    text: 'Desc/Situs',
    value: 'situsAddress',
    formatter: 'shortenCharacter',
    shortenCharacterlength: 20,
    sortable: false,
  },
  {
    text: 'Paid Date', value: 'payDate', formatter: 'shortDate', sortable: false,
  },
  { text: 'Paid By', value: 'paidBy', sortable: false },
];

const overpaymentsNRefundsHeader = [
  {
    text: 'Tax Year',
    value: 'taxYear',
  },
  { text: 'Tax ID', value: 'taxId' },
  { text: 'Parcel ID', value: 'propertyOrParcelId', formatter: 'pId' },
  {
    text: 'Tax District',
    value: 'taxDistrict',
  },
  { text: 'Date Overpaid', value: 'dateOverpaid', formatter: 'shortDate' },
  { text: 'Type', value: 'type' },
  {
    text: 'Payment Method',
    value: 'paymentMethod',
    formatter: 'customMethod',
    formatterTwo: 'forteHighlight',
  },
  {
    text: 'Tax Amount',
    value: 'taxAmt',
    align: 'right',
    formatter: 'amount',
  },
  {
    text: 'Over Paid',
    value: 'overPaidAmt',
    align: 'right',
    formatter: 'amount',
  },
  { text: 'Assigned To', value: 'assignedTo' },
  { text: 'Resolved', value: 'resolved', formatter: 'flagToYorEmpty' },
  { text: 'Warrant #', value: 'warrant' },
  { text: 'Issue Date', value: 'issueDate', formatter: 'shortDate' },
  { text: 'Paid Date', value: 'paidDate', formatter: 'shortDate' },
  { text: 'Comments', value: 'comments' },
];

const overpaymentsNRefundsDropDownList = [{ name: '', value: null }, { name: 'Adjustment', value: 'adj' }, { name: 'Overpayment', value: 'ovp' }, { name: 'Mortage Company', value: 'mtg' }];

// mirrors taxPaymentModesEnum on the backend (taxEnums.js) - kept as plain values here since
// the frontend doesn't share enum modules with the backend
const overpaymentPaymentMethodDropDownList = [
  { name: '', value: null },
  { name: 'In House Payments', value: 'inHousePay' },
  { name: 'Forte POS Payments', value: 'fPOSPay' },
  { name: 'Forte CC Payments', value: 'fCCPay' },
  { name: 'Forte E-Check Payments', value: 'feCheckPay' },
  { name: 'BOK Lockbox Payments', value: 'lockboxPay' },
];

const FORTE_PAYMENT_MODES = ['fPOSPay', 'fCCPay', 'feCheckPay'];

const paymentMethodLabel = (value) => {
  const found = overpaymentPaymentMethodDropDownList.find((opt) => opt.value === value);
  return found ? found.name : '';
};

export {
  AdjustmentsHeader, browsePaidByHeader, CommentsHeader,
  commentsHeaders, DelqHeader, FeesHeaders, HistoryTransactionListHeader,
  mobileHomeHeader, overpaymentsNRefundsDropDownList,
  overpaymentsNRefundsHeader, ownerTransactionsHeader,
  paymentsRecordsHeaders, PickListHeaders, ProtestPaymentsHeaders,
  ProtestPaymentsHeadersTwo, protestTaxFundsHeader, StatusCodesHeader,
  taxDetailsPaymentsHeaders, taxPaymPaymentsHeaders, TaxRollHeader,
  overpaymentPaymentMethodDropDownList, FORTE_PAYMENT_MODES, paymentMethodLabel,
};
